import type { PartialCrmMessages } from "./englishCrmMessages";

/** Auto-generated from docs/i18n/translation-matrix.csv — do not edit by hand */
export const swedishCrmMessages: PartialCrmMessages = {
  crm: {
    action: {
      reset_password: "Återställ lösenord",
    },
    activity: {
      added_company: "%{name} lade till kund",
      added_company_note: "%{name} lade till en anteckning om",
      added_contact: "%{name} lade till",
      added_deal: "%{name} lade till affär",
      added_note: "%{name} lade till en anteckning om",
      added_note_about_deal: "%{name} lade till en anteckning om affär",
      at_company: "på",
      load_more: "Ladda mer aktivitet",
      to: "till",
      you_added_company: "Du lade till kund",
      you_added_company_note: "Du lade till en anteckning om",
      you_added_contact: "Du lade till",
      you_added_deal: "Du lade till affär",
      you_added_note: "Du lade till en anteckning om",
      you_added_note_about_deal: "Du lade till en anteckning om affär",
    },
    auth: {
      confirm_password: "Bekräfta lösenord",
      confirmation_required: "Följ länken i det e-postmeddelande vi just skickade för att bekräfta ditt konto.",
      first_name: "Förnamn",
      last_name: "Efternamn",
      recovery_email_sent: "Om du är registrerad användare får du snart ett e-postmeddelande för återställning av lösenord.",
      sign_in_failed: "Det gick inte att logga in.",
      sign_in_google_workspace: "Logga in med Google Workplace",
      signup: {
        create_account: "Skapa konto",
        create_first_user: "Skapa det första användarkontot för att slutföra konfigurationen.",
        creating: "Skapar...",
        initial_user_created: "Första användaren skapad",
      },
      welcome_title: "Välkommen till Atomic CRM",
    },
    common: {
      activity: "Aktivitet",
      added: "tillagd",
      copied: "Kopierat!",
      copy: "Kopiera",
      details: "Detaljer",
      last_activity_with_date: "senaste aktivitet %{date}",
      load_more: "Ladda fler",
      loading: "Laddar...",
      me: "Jag",
      misc: "Övrigt",
      past: "Tidigare",
      read_more: "Läs mer",
      retry: "Försök igen",
      show_less: "Visa mindre",
      task_count: "%{smart_count} uppgift |||| %{smart_count} uppgifter",
    },
    config: {
      company_sectors: {
        "communication-services": "Kommunikationstjänster",
        "consumer-discretionary": "Cyklisk konsumtion",
        "consumer-staples": "Basala konsumvaror",
        energy: "Energi",
        financials: "Finans",
        "health-care": "Hälsovård",
        industrials: "Industri",
        "information-technology": "Informationsteknik",
        materials: "Material",
        "real-estate": "Fastigheter",
        utilities: "Försörjning",
      },
      deal_categories: {
        copywriting: "Copywriting",
        other: "Övrigt",
        "print-project": "Tryckprojekt",
        "ui-design": "UI-design",
        "website-design": "Webbdesign",
      },
      deal_stages: {
        delayed: "Försenad",
        "in-negociation": "Under förhandling",
        lost: "Förlorad",
        opportunity: "Möjlighet",
        "proposal-sent": "Offert skickad",
        won: "Vunnen",
      },
      note_statuses: {
        cold: "Kall",
        hot: "Het",
        "in-contract": "Under kontrakt",
        warm: "Varm",
      },
      task_types: {
        call: "Samtal",
        demo: "Demo",
        email: "E-post",
        "follow-up": "Uppföljning",
        lunch: "Lunch",
        meeting: "Möte",
        none: "Ingen",
        ship: "Leverans",
        "thank-you": "Tack",
      },
    },
    dashboard: {
      deals_chart: "Kommande affärsintäkter",
      deals_pipeline: "Affärspipeline",
      latest_activity: "Senaste aktivitet",
      latest_activity_error: "Fel vid inläsning av senaste aktivitet",
      latest_notes: "Mina senaste anteckningar",
      latest_notes_added_ago: "tillagd %{timeAgo}",
      stepper: {
        install: "Installera Atomic CRM",
        progress: "%{step}/3 klart",
        whats_next: "Vad händer nu?",
      },
      upcoming_tasks: "Kommande uppgifter",
    },
    email_lists: {
      all_categories: "Alla kategorier",
      brand_description: "E-postlistkontakter för %{brand}.",
      brand_title: "%{brand} kontakter",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        gobo_se: "Gobo SE",
        ljusdesign: "Ljusdesign",
      },
      create_contact: "Skapa kontakt",
      create_title: "Skapa kontakt",
      demo_unavailable: "E-postlistor kräver Encharge-konfiguration och är inte tillgängliga i demoläge.",
      description: "Visa och hantera Encharge-nyhetsbrevsabonnemang för Gobo-varumärken.",
      edit_title: "Redigera kontakt",
      empty: "Inga kontakter hittades.",
      exists_prompt: "En kontakt med denna e-post finns redan. Uppdatera den befintliga kontakten i stället?",
      fields: {
        categories: "Kommunikationskategorier",
        company: "Kund",
        contact_person: "Gobo-kontaktperson",
        email: "E-post",
        first_name: "Förnamn",
        last_name: "Efternamn",
        phone: "Telefon",
        postcode: "Postnummer",
      },
      loading: "Laddar...",
      loading_more: "Laddar fler...",
      match_company: "Matchad via kund",
      match_email: "Matchad via e-post",
      nav: "E-postlistor",
      saving: "Sparar...",
      search_placeholder: "Sök kontakter...",
      showing_count: "Visar %{count} kontakter i listan",
      title: "E-postlistor",
      update_existing: "Uppdatera befintlig",
      validation: {
        category_required: "Välj minst en kommunikationskategori.",
        required_fields: "Förnamn, efternamn och e-post krävs.",
      },
      widget_empty: "Inga nyhetsbrevsabonnemang hittades.",
      widget_no_email: "Lägg till en e-postadress för att se listprenumerationer.",
      widget_title: "E-postlistor",
    },
    header: {
      import_data: "Importera data",
    },
    image_editor: {
      change: "Byt",
      drop_hint: "Släpp en fil för att ladda upp, eller klicka för att välja.",
      editable_content: "Redigerbart innehåll",
      title: "Ladda upp och ändra bildstorlek",
      update_image: "Uppdatera bild",
    },
    import: {
      action: {
        download_error_report: "Ladda ner felrapporten",
        import: "Importera",
        import_another: "Importera en annan fil",
      },
      error: {
        unable: "Kunde inte importera den här filen.",
      },
      idle: {
        description_1: "Du kan importera användare, kunder, kontakter, anteckningar och uppgifter.",
        description_2: "Data måste finnas i en JSON-fil som matchar följande exempel:",
      },
      status: {
        all_success: "Alla poster importerades.",
        complete: "Import klar.",
        failed: "Misslyckades",
        imported: "Importerad",
        in_progress: "Import pågår — lämna inte den här sidan.",
        some_failed: "Vissa poster importerades inte.",
        table_caption: "Importstatus",
      },
      title: "Importera data",
    },
    language: "Språk",
    mobile_nav: {
      close_menu: "Stäng",
      mega_menu_title: "Meny",
      my_tasks: "Mina uppgifter",
      open_menu: "Öppna meny",
      section_account: "Konto",
      section_main: "Huvud",
    },
    navigation: {
      label: "CRM-navigering",
    },
    profile: {
      inbound: {
        description: "Du kan börja skicka e-post till serverns inkommande e-postadress, t.ex. genom att lägga till den i fältet %{field}. Atomic CRM behandlar e-postmeddelanden och lägger till anteckningar på motsvarande kontakter.",
        title: "Inkommande e-post",
      },
      mcp: {
        description: "Använd denna URL för att ansluta din AI-assistent till dina CRM-data via Model Context Protocol (MCP).",
        title: "MCP Server",
      },
      password: {
        change: "Byt lösenord",
      },
      password_reset_sent: "Ett återställningsmeddelande har skickats till din e-postadress",
      record_not_found: "Posten hittades inte",
      title: "Profil",
      update_error: "Ett fel uppstod. Försök igen",
      updated: "Din profil har uppdaterats",
    },
    recent_website_activity: {
      demo_unavailable: "Senaste webbaktivitet kräver Leadboxer-konfiguration och är inte tillgänglig i demoläge.",
      empty: "Ingen senaste webbaktivitet hittades",
      loading: "Laddar...",
      match_reason: {
        domain: "Matchad via domän",
        domain_alias: "Matchad via domänalias",
        email_domain: "Matchad via e-postdomän",
        linkedin: "Matchad via LinkedIn",
        name: "Matchad via namn",
      },
      summary: "%{count} besök · %{visits} sessioner · %{events} sidvisningar (senaste)",
      title: "Senaste webbaktivitet",
    },
    settings: {
      app_title: "Apptitel",
      companies: {
        segments: "Segment",
      },
      dark_mode_logo: "Logotyp för mörkt läge",
      deals: {
        categories: "Kategorier",
        currency: "Valuta",
        pipeline_help: "Välj vilka affärssteg som ska räknas som pipeline-affärer.",
        pipeline_statuses: "Pipeline-statusar",
        stages: "Steg",
      },
      light_mode_logo: "Logotyp för ljust läge",
      notes: {
        statuses: "Statusar",
      },
      preferences: "Inställningar",
      reset_defaults: "Återställ till standard",
      save_error: "Det gick inte att spara konfigurationen",
      saved: "Konfiguration sparad",
      saving: "Sparar...",
      sections: {
        bc_sync: "BC Sync",
        branding: "Varumärke",
        notifications: "Aviseringar",
      },
      tasks: {
        types: "Typer",
      },
      title: "Inställningar",
      validation: {
        duplicate: "Dubblett %{display_name}: %{items}",
        entities: {
          categories: "kategorier",
          stages: "steg",
        },
        in_use: "Kan inte ta bort %{display_name} som fortfarande används av affärer: %{items}",
        validating: "Validerar…",
      },
    },
    theme: {
      dark: "Mörkt",
      label: "Tema",
      light: "Ljust",
      system: "System",
    },
    validation: {
      invalid_linkedin_url: "URL måste vara från linkedin.com",
      invalid_url: "Måste vara en giltig URL",
    },
    visitor_insights: {
      brand_description: "Webbbesöksdata för %{brand}.",
      brand_title: "%{brand} besöksinsikter",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        gobo_se: "Gobo SE",
        ljusdesign: "Ljusdesign",
      },
      columns: {
        employees: "Anställda",
        events: "Händelser",
        industry: "Bransch",
        last_activity: "Senaste aktivitet",
        last_channel: "Senaste kanal",
        summary: "Sammanfattning",
        visits: "Besök",
      },
      demo_unavailable: "Besöksinsikt kräver Leadboxer-konfiguration och är inte tillgänglig i demoläge.",
      description: "Visa identifierade organisationer som besöker era webbplatser.",
      empty: "Inga besökare hittades för denna period.",
      fields: {
        employees: "Anställda",
        industry: "Bransch",
        location: "Plats",
        phone: "Telefon",
        score: "Poäng",
        tags: "Taggar",
        website: "Webbplats",
      },
      loading: "Laddar...",
      loading_sessions: "Laddar sessioner...",
      nav: "Besöksinsikter",
      no_sessions: "Inga sessioner hittades för detta lead.",
      period: {
        last_24h: "Senaste 24 timmarna",
        last_30d: "Senaste 30 dagarna",
        last_3d: "Senaste 3 dagarna",
        last_7d: "Senaste 7 dagarna",
      },
      session_events: "Sessionshändelser",
      title: "Besöksinsikter",
      view_customer: "Visa kund",
    },
    voice_agent: {
      language: "Röstspråk",
    },
    bc_environment: {
      label: "Huvudsaklig BC-miljö",
    },
  },
  resources: {
    campaigns: {
      assignee: {
        required: "Välj en ansvarig",
      },
      complete_note: {
        placeholder: "Skriv en anteckning om detta besök eller samtal…",
        save: "Spara anteckning",
        saved_to_company: "Anteckningen sparas på kunden: %{name}",
        saved_to_contact: "Anteckningen sparas på kontakten: %{name}",
        skip: "Slutför utan anteckning",
        success: "Uppgift slutförd",
        title: "Lägg till anteckning till uppgift",
      },
      fields: {
        assignee: "Ansvarig",
        description: "Beskrivning",
        instructions: "Instruktioner",
        kind: "Uppgiftstyp",
        name: "Namn",
        product_name: "Produkt",
        status: "Status",
        targets: "Mål",
        title: "Titel",
      },
      generate: {
        action: "Generera uppgifter",
        confirm: "Generera",
        created: "Skapade",
        deleted: "Borttagna",
        fallback: "Reservsäljare",
        fallback_help: "Välj en reservsäljare för mål utan tilldelad säljare.",
        missing: "Överhoppade (ingen säljare)",
        reconcile: "Avstäm uppgifter",
        skipped: "Överhoppade",
        success: "Uppgifter genererade",
      },
      kinds: {
        follow_up: "Uppföljning",
        meeting: "Möte",
        newsletter: "Skicka nyhetsbrev",
        personal_task: "Personlig uppgift",
        phone_call: "Telefonsamtal",
        send_info: "Skicka produktinfo",
        send_samples: "Skicka prover",
        visit_demo: "Besök och demo",
      },
      metadata: {
        materials: "Material att skicka",
        meeting_format: "Mötesformat (in_person eller online)",
        newsletter_subject: "Ämne för nyhetsbrev",
        notes: "Anteckningar",
        product_to_demo: "Produkt att demonstrera",
        sample_description: "Provbeskrivning",
        talk_points: "Samtalsämnen",
      },
      name: "Kampanj |||| Kampanjer",
      open_tasks: {
        all_completed: "Alla uppgifter slutförda.",
        campaign_task: "Kampanjuppgift",
        company_fallback: "Kund #%{id}",
        contact_fallback: "Kontakt #%{id}",
        show_completed: "Visa slutförda",
        title: "Uppgifter",
      },
      progress: {
        label: "Framsteg",
        overdue_count: "%{count} försenade",
      },
      status: {
        active: "Aktiv",
        completed: "Slutförd",
        draft: "Utkast",
        open: "Öppen",
        overdue: "Försenad",
        snoozed: "Snoozad",
      },
      tabs: {
        definitions: "Uppgiftsdefinitioner",
        my_tasks: "Mina uppgifter",
        overview: "Översikt",
      },
      targets: {
        add: "Lägg till mål",
        required: "Lägg till minst ett mål",
      },
      task_definitions: {
        add: "Lägg till uppgiftsdefinition",
        edit: "Redigera uppgiftsdefinition",
        empty: "Inga uppgiftsdefinitioner ännu.",
        generated: "Genererad",
        targets: "mål",
      },
    },
    companies: {
      action: {
        create: "Skapa kund",
        edit: "Redigera kund",
        new: "Ny kund",
        show: "Visa kund",
      },
      added_on: "Tillagd %{date}",
      autocomplete: {
        create_error: "Ett fel uppstod vid skapande av kunden",
        create_item: "Skapa %{item}",
        create_label: "Börja skriva för att skapa en ny kund",
      },
      empty: {
        bc_sync_description: "Kunder synkroniseras från Business Central. Gå till Inställningar → BC Sync, eller vänta på den nattliga synkroniseringen.",
        description: "Det verkar som att din kundlista är tom.",
        title: "Inga kunder hittades",
      },
      field_categories: {
        additional_info: "Ytterligare information",
        address: "Adress",
        contact: "Kontakt",
        context: "Kontext",
      },
      fields: {
        address: "Adress",
        city: "Stad",
        context_links: "Kontextlänkar",
        country: "Land",
        created_at: "Skapad",
        description: "Beskrivning",
        linkedin_url: "LinkedIn-URL",
        name: "Kundnamn",
        nb_contacts: "Antal kontakter",
        phone_number: "Telefonnummer",
        revenue: "Omsättning",
        sales_id: "Kontoansvarig",
        sector: "Segment",
        segments: "Segment",
        size: "Storlek",
        state_abbr: "Län",
        tax_identifier: "Organisationsnummer",
        website: "Webbplats",
        zipcode: "Postnummer",
      },
      filters: {
        only_mine: "Endast kunder jag ansvarar för",
      },
      followed_by: "Säljare: %{name}",
      followed_by_you: "Säljare: du",
      forcedCaseName: "Kund",
      name: "Kund |||| Kunder",
      nb_contacts: "%{smart_count} kontakt |||| %{smart_count} kontakter",
      nb_deals: "%{smart_count} affär |||| %{smart_count} affärer",
      no_contacts: "Ingen kontakt",
      sizes: {
        fifty_to_two_hundred_forty_nine_employees: "50-249 anställda",
        one_employee: "1 anställd",
        ten_to_forty_nine_employees: "10-49 anställda",
        two_hundred_fifty_or_more_employees: "250 eller fler anställda",
        two_to_nine_employees: "2-9 anställda",
      },
    },
    contacts: {
      action: {
        add: "Lägg till kontakt",
        add_first: "Lägg till din första kontakt",
        browse_synced: "Bläddra bland synkroniserade kontakter",
        create: "Skapa kontakt",
        edit: "Redigera kontakt",
        export_vcard: "Exportera till vCard",
        new: "Ny kontakt",
        show: "Visa kontakt",
      },
      background: {
        added_on: "Tillagd %{date}",
        followed_by: "Säljare: %{name}",
        followed_by_you: "Säljare: du",
        last_activity_on: "Senaste aktivitet %{date}",
        status_none: "Ingen",
      },
      bulk_tag: {
        action: "Tagga",
        back: "Tillbaka till taggar",
        create_description: "Skapa en ny tagg och tillämpa den på valda kontakter.",
        description: "Välj en befintlig tagg eller skapa en ny för valda kontakter.",
        empty: "Inga taggar ännu. Skapa en för att tagga valda kontakter.",
        error: "Det gick inte att lägga till tagg på kontakter",
        noop: "Valda kontakter har redan denna tagg",
        success: "Tagg tillagd på %{smart_count} kontakt |||| Tagg tillagd på %{smart_count} kontakter",
        title: "Lägg till tagg på kontakter",
      },
      empty: {
        bc_sync_description: "Kontakter synkroniseras från Business Central. Gå till Inställningar → BC Sync, eller vänta på den nattliga synkroniseringen.",
        description: "Det verkar som att din kontaktlista är tom.",
        title: "Inga kontakter hittades",
      },
      field_categories: {
        background_info: "Bakgrund",
        identity: "Identitet",
        misc: "Övrigt",
        personal_info: "Personlig information",
        position: "Position",
      },
      fields: {
        background: "Bakgrund (bio, hur ni träffades m.m.)",
        company_id: "Kund",
        email: "E-post",
        email_jsonb: "E-postadresser",
        first_name: "Förnamn",
        has_newsletter: "Har nyhetsbrev",
        last_name: "Efternamn",
        last_seen: "Senast sedd",
        linkedin_url: "LinkedIn-URL",
        phone_jsonb: "Telefonnummer",
        phone_number: "Telefonnummer",
        sales_id: "Kontoansvarig",
        title: "Titel",
      },
      filters: {
        before_last_month: "Före förra månaden",
        before_this_month: "Före denna månad",
        before_this_week: "Före denna vecka",
        managed_by_me: "Hanteras av mig",
        search: "Sök namn, kund...",
        tags: "Taggar",
        tasks: "Uppgifter",
        this_week: "Denna vecka",
        today: "Idag",
      },
      forcedCaseName: "Kontakt",
      hot: {
        empty_change_status: "Ändra en kontakts status genom att lägga till en anteckning på kontakten och klicka på \"visa alternativ\".",
        empty_hint: "Kontakter med status \"het\" visas här.",
        title: "Heta kontakter",
      },
      import: {
        button: "Importera CSV",
        complete: "Kontaktimport klar. Importerade %{importCount} kontakter med %{errorCount} fel",
        contacts_label: "kontakt |||| kontakter",
        csv_file: "CSV-fil",
        error: "Kunde inte importera den här filen. Kontrollera att du har angett en giltig CSV-fil.",
        imported: "Importerad",
        progress: "Importerade %{importCount} / %{rowCount} kontakter med %{errorCount} fel.",
        remaining_time: "Beräknad återstående tid:",
        running: "Importen pågår — stäng inte den här fliken.",
        sample_download: "Ladda ner CSV-exempel",
        sample_hint: "Här är ett CSV-exempel som du kan använda som mall",
        stop: "Stoppa import",
        title: "Importera kontakter",
      },
      inputs: {
        genders: {
          female: "Hon/Henne",
          male: "Han/Honom",
          nonbinary: "Hen/Hen",
        },
        personal_info_types: {
          home: "Privat",
          other: "Övrigt",
          work: "Arbete",
        },
      },
      list: {
        error_loading: "Fel vid inläsning av kontakter",
      },
      merge: {
        action: "Slå samman med en annan kontakt",
        confirm: "Slå samman kontakter",
        current_contact: "Aktuell kontakt (tas bort)",
        description: "Slå samman denna kontakt med en annan.",
        error: "Det gick inte att slå samman kontakter",
        merging: "Slår samman...",
        no_additional_data: "Ingen ytterligare data att slå samman",
        select_target: "Välj en kontakt att slå samman med",
        success: "Kontakter sammanslagna",
        target_contact: "Målkontakt (behålls)",
        title: "Slå samman kontakt",
        warning_description: "All data överförs till den andra kontakten. Åtgärden kan inte ångras.",
        warning_title: "Varning: Destruktiv åtgärd",
        what_will_be_merged: "Detta slås samman:",
      },
      name: "Kontakt |||| Kontakter",
      position_at: "%{title} på",
      position_at_company: "%{title} på %{company}",
      part_of_company: "Del av %{name}",
      open_company: "Öppna kund",
    },
    deals: {
      action: {
        back_to_deal: "Tillbaka till affär",
        create: "Skapa affär",
        new: "Ny affär",
      },
      archived: {
        action: "Arkivera",
        error: "Fel: affär inte arkiverad",
        list_title: "Arkiverade affärer",
        success: "Affär arkiverad",
        title: "Arkiverad affär",
        view: "Visa arkiverade affärer",
      },
      empty: {
        before_create: "innan du skapar en affär.",
        description: "Det verkar som att din affärslista är tom.",
        title: "Inga affärer hittades",
      },
      field_categories: {
        misc: "Övrigt",
      },
      fields: {
        amount: "Budget",
        category: "Kategori",
        company_id: "Kund",
        contact_ids: "Kontakter",
        description: "Beskrivning",
        expected_closing_date: "Förväntat avslutsdatum",
        name: "Namn",
        stage: "Steg",
      },
      inputs: {
        linked_to: "Kopplad till",
      },
      invalid_date: "Ogiltigt datum",
      name: "Affär |||| Affärer",
      unarchived: {
        action: "Skicka tillbaka till tavlan",
        error: "Fel: affär inte återställd",
        success: "Affär återställd",
      },
      updated: "Affär uppdaterad",
    },
    notes: {
      action: {
        add: "Lägg till anteckning",
        add_first: "Lägg till din första anteckning",
        add_this: "Lägg till denna anteckning",
        delete: "Radera anteckning",
        edit: "Redigera anteckning",
        update: "Uppdatera anteckning",
      },
      actions: {
        attach_document: "Bifoga dokument",
      },
      added: "Anteckning tillagd",
      author_added: "%{name} lade till en anteckning",
      deleted: "Anteckning raderad",
      empty: "Inga anteckningar ännu",
      fields: {
        attachments: "Bilagor",
        contact_id: "Kontakt",
        date: "Datum",
        deal_id: "Affär",
        status: "Status",
      },
      forcedCaseName: "Anteckning",
      inputs: {
        add_note: "Lägg till en anteckning",
        options_hint: "(bifoga filer eller ändra detaljer)",
        show_options: "Visa alternativ",
      },
      list: {
        error_loading: "Fel vid inläsning av anteckningar",
      },
      me: "Jag",
      name: "Anteckning |||| Anteckningar",
      note_for_contact: "Anteckning för %{name}",
      sheet: {
        create: "Skapa anteckning",
        create_for: "Skapa anteckning för %{name}",
        edit: "Redigera anteckning",
        edit_for: "Redigera anteckning för %{name}",
      },
      stepper: {
        hint: "Gå till en kontaktsida och lägg till en anteckning",
      },
      validation: {
        note_or_attachment_required: "En anteckning eller bilaga krävs",
      },
      you_added: "Du lade till en anteckning",
    },
    sales: {
      action: {
        new: "Ny användare",
      },
      create: {
        error: "Ett fel uppstod vid skapande av användaren.",
        success: "Användare skapad. Personen får snart ett e-postmeddelande för att ange lösenord.",
        title: "Skapa ny användare",
      },
      edit: {
        error: "Ett fel uppstod. Försök igen.",
        record_not_found: "Posten hittades inte",
        success: "Användare uppdaterad",
        title: "Redigera %{name}",
      },
      fields: {
        administrator: "Admin",
        disabled: "Inaktiverad",
        email: "E-post",
        first_name: "Förnamn",
        last_name: "Efternamn",
      },
      name: "Användare |||| Användare",
    },
    tags: {
      action: {
        add: "Lägg till tagg",
        create: "Skapa ny tagg",
      },
      dialog: {
        color: "Färg",
        create_title: "Skapa ny tagg",
        edit_title: "Redigera tagg",
        name_label: "Taggnamn",
        name_placeholder: "Ange taggnamn",
      },
      name: "Tagg |||| Taggar",
    },
    tasks: {
      action: {
        add: "Lägg till uppgift",
        create: "Skapa uppgift",
        edit: "Redigera uppgift",
      },
      actions: {
        postpone_next_week: "Skjut upp till nästa vecka",
        postpone_tomorrow: "Skjut upp till imorgon",
        title: "uppgiftsåtgärder",
      },
      added: "Uppgift tillagd",
      deleted: "Uppgift raderad",
      dialog: {
        create: "Skapa uppgift",
        create_for: "Skapa uppgift för %{name}",
      },
      empty: "Inga uppgifter ännu",
      empty_list_hint: "Uppgifter som lagts till på dina kontakter visas här.",
      fields: {
        contact_id: "Kontakt",
        due_date: "Förfallodatum",
        due_short: "förfaller",
        text: "Beskrivning",
        type: "Typ",
      },
      filters: {
        campaign_tasks: "Endast kampanjuppgifter",
        later: "Senare",
        overdue: "Försenad",
        this_week: "Denna vecka",
        today: "Idag",
        tomorrow: "Imorgon",
        with_pending: "Med väntande uppgifter",
      },
      forcedCaseName: "Uppgift",
      name: "Uppgift |||| Uppgifter",
      recurrence: {
        badge: "Återkommande",
        custom: "Anpassad",
        days: "Dagar",
        enabled: "Återkommande uppgift",
        end_date: "Slutdatum",
        every_count: "Intervall",
        every_count_help: "Använd 1 för varje intervall, eller högre för varje N:e period.",
        every_day: "Varje dag",
        every_month: "Varje månad",
        every_unit: "Enhet",
        every_week: "Varje vecka",
        every_year: "Varje år",
        has_end_date: "Ange slutdatum",
        months: "Månader",
        weeks: "Veckor",
        years: "År",
      },
      regarding_company: "(Ang.: %{name})",
      regarding_contact: "(Ang.: %{name})",
      sheet: {
        edit: "Redigera uppgift",
        edit_for: "Redigera uppgift för %{name}",
      },
      updated: "Uppgift uppdaterad",
    },
  },
};

